import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, patch, post, put } from "helpers/api_helper"
import {
  UPLOAD_CANDIDATES_FOR_CARDS,
  GET_CARD_BATCHES,
  GET_LIST_OF_CARDS_JOBS,
  GET_LIST_OF_CARDS_NOT_ISSUED,
  GET_LIST_OF_CARDS_ISSUED,
} from "helpers/url_helper"

export const uploadCardCandidates = createAsyncThunk(
  UPLOAD_CANDIDATES_FOR_CARDS,
  async payload => {
    const response = await formDataPost(UPLOAD_CANDIDATES_FOR_CARDS, payload)
    return response
  }
)
export const getCardBatches = createAsyncThunk(
  GET_CARD_BATCHES,
  async payload => {
    const response = await post(GET_CARD_BATCHES, payload)
    return response
  }
)

export const getCardsAsPerJobs = createAsyncThunk(
  GET_LIST_OF_CARDS_JOBS,
  async payload => {
    const response = await post(GET_LIST_OF_CARDS_JOBS, payload)
    return response
  }
)

export const getNotIssuedCandidates = createAsyncThunk(
  GET_LIST_OF_CARDS_NOT_ISSUED,
  async payload => {
    const response = await post(GET_LIST_OF_CARDS_NOT_ISSUED, payload)
    return response
  }
)
export const getIssuedCandidates = createAsyncThunk(
  GET_LIST_OF_CARDS_ISSUED,
  async payload => {
    const response = await post(GET_LIST_OF_CARDS_ISSUED, payload)
    return response
  }
)
